module.exports = __webpack_public_path__ + "static/greytexture.4f318e25.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/greytexture.png
// module id = 623
// module chunks = 114276838955818